'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = tabQBUrl;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 资讯频道QB地址
 * @param  {String} options.id
 * @param  {String} options.ch
 * @param  {String} options.bizid
 * @return {String}
 */
function tabQBUrl(_ref) {
  var id = _ref.id,
      ch = _ref.ch,
      _ref$bizid = _ref.bizid,
      bizid = _ref$bizid === undefined ? '1' : _ref$bizid;

  var params = {
    b_f: ch,
    bizid: bizid
  };

  // cid 必须是第一参数，终端限制=。=
  return 'qb://ext/read/portal?cid=' + id + '&' + _queryString2.default.stringify(params);
} /*
   * @Author: edvardchen
   * @Date:   2017-03-27 15:13:44
   * @Last Modified by:   edvardchen
   * @Last Modified time: 2017-03-28 15:58:49
   */